module.exports = function(category_id) {
  return App.Category[category_id]['url'];
};



// WEBPACK FOOTER //
// ./webroot/js/hbs_helpers/getCategoryUrl.js